﻿(function () {
  const LoadingCounter = {
    n: 0,
    inc() {
      if (this.n++ === 0 && window.Site?.ShowLoading) {
        Site.ShowLoading();
      }
    },
    dec() {
      this.n = Math.max(0, this.n - 1);
      if (this.n === 0 && window.Site?.HideLoading) {
        Site.HideLoading();
      }
    },
  };

  if (window.jQuery) {
    $(document)
      .on('ajaxSend.globalLoader', () => LoadingCounter.inc())
      .on('ajaxComplete.globalLoader', () => LoadingCounter.dec());
  }

  if (window.fetch) {
    const _fetch = window.fetch.bind(window);
    window.fetch = function (...args) {
      LoadingCounter.inc();
      return _fetch(...args).finally(() => LoadingCounter.dec());
    };
  }
})();
